<template>
  <div class="template-preview__wrap">
    <h3 class="flow_table_title template-preview__title">{{`${templateInfo.name ? `${templateInfo.name}列表` : ""}`}}</h3>
    <span v-if="html">
      <div  :style="conheight">
    <template-dynamic-view
        :templateKey="templateKey"
        :html="html"
        :taskType="taskType"
        :single="single"
        :dataView="dataView"
        :isJoinFlow="isJoinFlow"
        :parameterqQuerys="parameterqQuerys"
        :templateInfo="templateInfo"
        class="template-preview__content"
        
      />
      </div>
      
    </span>
    <div class="loaded-fail__div" v-if="loadedFail">报表不存在...</div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Message } from "element-ui";
import { Loading } from "element-ui";
import HtCheckbox from "@/components/control/HtCheckbox.vue";
import HtDialog from "@/components/control/HtDialog.vue";
import TemplateDynamicView from "@/components/dataTemplate/TemplateDynamicView.vue";
import HtDialogBtn from "@/components/control/htDialogBtn.vue";
import VRuntimeTemplate from "v-runtime-template";
import utils from "@/utils.js";
import { Base64 } from "js-base64";

export default {
  name: "templatePreview",
  props: {
    templateKey: String,
    parameterqQuerys: String,
    single: String,
    taskType: {
      default: ""
    },
    defKey: String,
    dataView: Object,
    isJoinFlow: {
      default: false
    }
  },
  data() {
    return {
      html: "",
      templateInfo: {},
      tableData: { selectRows: [], querys: "" },
      dialogExportVisible: false,
      exportData: { getType: "all", expField: [] },
      displayFields: [],
      exportSellection: [],
      searchForm: { F_xb: "", F_xm: "" },
      queryForm: {
        queryData: ""
      },
      formType: false,
      labelPosition: "left",
      incons: "el-icon-arrow-down",
      options: {
        fullscreen: true,
        lock: true
      },
       conheight: { height: "" },
      loadedFail: false,
    };
  },
  computed: {
    ...mapState({
      dialogSubVisible: state => state.form.bpmTemplateSubData.dialogSubVisible,
      tabs: state => state.form.bpmTemplateSubData.tabs,
      ents: state => state.form.bpmTemplateSubData.ents,
      refId: state => state.form.bpmTemplateSubData.refId
    })
  },
  components: {
    VRuntimeTemplate,
    HtCheckbox,
    HtDialog,
    HtDialogBtn,
    TemplateDynamicView
  },
  watch: {
    templateKey: function(newVal) {
      if (newVal) {
        this.init();
      }
    }
  },
  created() {
    this.init();
    window.addEventListener("resize", this.getHeight);
      this.getHeight();
  },
  methods: {
    getHeight() {
      this.conheight.height = window.innerHeight - 100 + "px";
    },
    // 根据当前formKey初始化
    init() {
      const loading = this.$loading(this.options);
      let _me = this;
      this.$store.dispatch("form/getBpmDataTemplateInfo", {
        templateKey: this.templateKey
      }).then(result => {
        if (result.state) {
          _me.templateInfo = result.value;
          loading.close();
        }
      });
      this.$store
        .dispatch("form/getTemplateDataListForm", this.templateKey)
        .then(result => {
          if (result.state) {
            _me.html = result.value;
          }else{
            this.loadedFail = true;
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.template-preview__wrap{
  height: 100%;
  .template-preview__content{
    height: calc(100% - 69px);
    /deep/ .el-container{
      height: 100%;
    }
  }
}

/deep/ .el-table th.todo-header-row{
  height: 44px;
  text-align: center;
  color: #000000;
  background: #e6e6e6;
  font-size: 14px;
}


/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
/deep/ .el-table .todo-row{
  height: 41px;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
}

/deep/.el-table--border th,
/deep/.el-table--border td {
    //border-right:1px dashed #000000;
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}


/deep/ .el-table__body tr.hover-row > td,.el-table__body tr.hover-row.current-row > td,.el-table__body tr.hover-row.striped-row > td,.el-table__body tr.hover-row.--striped.current-row > td{
  background-color:#fdfdaf !important;
}

.el-container {
  background-color: #fff;
}
/deep/ .el-collapse-item__content{
  display: flex;
  // flex-wrap: wrap;
  .form__row{
    width: 100%;
    margin-left: 0;
    .el-form{
      display: flex;
      flex-direction: row;
      // flex-wrap: wrap;
    }
  }
}
/deep/.el-table--small th,
/deep/ .el-table--small td {
  padding: 1px 0;
}

/deep/.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
  line-height: unset;
}
/deep/ .el-dialog__body {
 padding: 15px 10px;
}

/deep/.btn__row {
  // margin-bottom: 20px;
  margin-left: 20px;
  display: flex;
  min-width: 14%;
}
/deep/ .el-footer{
  display: flex;
  justify-content: flex-end;
}
.el-header {
  border-bottom: 1.5px solid #ededed;
}

.i {
  margin-right: 4px;
}

.todo-subject {
  cursor: pointer;
}

.todo-subject:hover {
  color: $--theme-color;
}




/deep/ .el-checkbox {
  margin-left: 15px;
}

/deep/ .el-radio {
  margin-left: 15px;
}

/deep/ .el-button{
  margin-left: 0px;
}
.loaded-fail__div {
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #f56c6c;
}
/deep/ .el-footer{
  justify-content: flex-start;
}
@media (max-width:1440px) {
  /deep/ .el-collapse-item__content{
    flex-wrap: wrap;
    .form__row{
      margin-left: 20px;
    }
  }
}
</style>
